/**
 * Age in whole years from a date-only "YYYY-MM-DD" string.
 *
 * The string is split by hand rather than passed to `new Date()`, which reads
 * date-only strings as UTC midnight: in Dallas that is the previous evening,
 * so a child would turn a year older a day late.
 */
export const ageFromDateOfBirth = (
  dateOfBirth: string | null | undefined,
  today: Date = new Date(),
): number | null => {
  if (!dateOfBirth) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateOfBirth);
  if (!match) return null;
  const [, year, month, day] = match.map(Number);
  let age = today.getFullYear() - year;
  const hadBirthdayThisYear =
    today.getMonth() + 1 > month ||
    (today.getMonth() + 1 === month && today.getDate() >= day);
  if (!hadBirthdayThisYear) age -= 1;
  return age >= 0 ? age : null;
};
